module.exports = __webpack_public_path__ + "static/media/boca.8829bc36.png";